import { IconButton, TextField, Tooltip } from '@mui/material';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import { useEffect, useState } from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { v4 as uuidv4 } from 'uuid';
import { Box } from '@mui/system';
import { RadioEntries } from '../types';


interface RadioButtonsExtraPropsProps {
  entries?: RadioEntries[];
  getEntries: (entries: RadioEntries[]) => void;
}

function RadioButtonsExtraProps(props: RadioButtonsExtraPropsProps) {
  const { entries = [] } = props;

  
  const [radioButtonEntries, setRadioButtonEntries] =
  useState<RadioEntries[]>(entries || []);
  
  useEffect(() => {
    props.getEntries && props.getEntries(radioButtonEntries);
  }, [radioButtonEntries]);

  const deleteEntry = (uuid: string) => {
    setRadioButtonEntries(radioButtonEntries.filter((entry) => entry.key !== uuid));
  };


  const updateEntryLabelUserTyping = (e: any, uuid: string) => {
    const oldEntries = [...radioButtonEntries];

    const newEntries = oldEntries.map((entry: any) => {
      if (entry.key === uuid) {
        entry.label = e.target.value;
      }
      return entry;
    });
    setRadioButtonEntries(newEntries);
  };

  const addExtraRadioProp = () => {
    setRadioButtonEntries([...radioButtonEntries, { label: '', key: uuidv4() }]);
  };
  return (<>
    <Box
      mt={2}
      display='flex'
      flexDirection='column'
      gap={2}>
      {
        radioButtonEntries.map((entry, index: number) => {
          return <Box
            display='flex'
            alignItems='center'
            key={entry.key}>
            <TextField
              label={`Radio Επιλογή ${index + 1}`}
              onChange={(e) => updateEntryLabelUserTyping(e, entry.key)} type='text'
              value={entry.label} />

            <Tooltip title='Διαγραφή Επιλογής'>
              <IconButton onClick={() => deleteEntry(entry.key)}>
                <HighlightOffIcon color='error' />
              </IconButton>
            </Tooltip>

          </Box>;
        })
      }
    </Box>

    <Box
      mt={2}
      display='flex'
      justifyContent='center'>
      <Tooltip title='Προσθήκη Επιλογής'>
        <IconButton onClick={addExtraRadioProp}>
          <ControlPointOutlinedIcon />
        </IconButton>
      </Tooltip>
    </Box>

  </>);
}

export default RadioButtonsExtraProps;